import { Navigate } from "react-router-dom";
import useBetterParams from "../../utils/useBetterParams.js";

export const VideoPlayerEmbedRedirect = () => {
  const { id: sessionId } = useBetterParams();
  return <Navigate to={`/session/${sessionId}/embed`} />;
};
